// NGRX
import {Store, select} from '@ngrx/store';
// CRUD
import {BaseDataSource, QueryResultsModel} from '../../_base/crud';
// State
import {AppState} from '../../reducers';
import {
    selectToesInStore,
    selectToesPageLoading,
    selectToesShowInitWaitingMessage
} from '../_selectors/toe.selectors';

export class ToesDataSource extends BaseDataSource {
    constructor(private store: Store<AppState>) {
        super();

        this.loading$ = this.store.pipe(
            select(selectToesPageLoading),
        );

        this.isPreloadTextViewed$ = this.store.pipe(
            select(selectToesShowInitWaitingMessage)
        );

        this.store.pipe(
            select(selectToesInStore),
        ).subscribe((response: QueryResultsModel) => {
            this.paginatorTotalSubject.next(response.totalCount);
            this.entitySubject.next(response.items);
        });
    }
}
